import React, { useEffect, useMemo, useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";

import { NewCampaign, AgentCustomerList, CreateAgent } from "./pages/index";
import AddUser from "./pages/Admin/AddUser";

import { AGENT_ACTIVITY } from "./utils/ApiUrls";
import { Layout, RequireAuth, PersistLogin } from "./components";
import {
  Navigate,
  useNavigate,
  useLocation,
  Route,
  Routes,
} from "react-router-dom";
import { ROLES } from "./utils/Data";
import useAuth from "./hooks/useAuth";
import CallFeedback from "./components/Feedbacks/Feedback";
import Adminroutes, { CommonRoutes, getRoutesByAuth } from "./routes";
import useFetch from "./hooks/useFetch";
import { SIPProvider } from "./context/SIPContext";
import useAgentHeartbeat from "./hooks/useAgentHeartbeat";

const API_ENDPOINT = process.env.REACT_APP_WS_URL;

function getOrCreateTabId() {
  let tabId = sessionStorage.getItem("tab_id");
  if (!tabId) {
    tabId = crypto.randomUUID();
    sessionStorage.setItem("tab_id", tabId);
  }
  return tabId;
}

function App() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const fetchData = useFetch();

  const tabId = useRef(getOrCreateTabId()).current;
  const innerRef = useRef(null);

  const [showMultiTabWarning, setShowMultiTabWarning] = useState(false);
  const [tabCounterEnd, setTabCounterEnd] = useState(true);
  
  const handleHeartbeatStatus = (serverStatus) => {
    innerRef.current?.setOnlineStatusColour(serverStatus);
  };
  const setOnlineStatus = (status) => {
    innerRef.current?.setOnlineStatus(status);
  };
  const tabCounterEndCounterHandle=()=>{

    setTabCounterEnd(false);
    setShowMultiTabWarning(false)
    
    setTimeout(() => {
      setTabCounterEnd(true);
      setShowMultiTabWarning(false)
    }, 16000);
  }
  useAgentHeartbeat(auth, tabId, () => setShowMultiTabWarning(true), handleHeartbeatStatus, setOnlineStatus);

  useEffect(() => {
    if (
      location.pathname == "/" &&
      auth &&
      auth?.roles &&
      localStorage.getItem("IsLoggedIn")
    ) {
      auth?.roles?.includes("sys_admin")
        ? navigate("/admin/dashboard", { replace: true })
        : navigate("/agent/dashboard", { replace: true });
    }

    const handleTabClose = async (event) => {
      event.preventDefault();
      event.returnValue = "";

      console.log("beforeunload event triggered");
      return "";
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };

  }, [auth, location.pathname]);

  // useEffect(() => {
  //   if (
  //     location.pathname == "/" &&
  //     auth &&
  //     auth?.roles &&
  //     localStorage.getItem("IsLoggedIn")
  //   ) {
  //     auth?.roles?.includes("sys_admin")
  //       ? navigate("/admin/dashboard", { replace: true })
  //       : navigate("/agent/dashboard", { replace: true });
  //   }

  //   const handleTabClose = async (event) => {
  //     event.preventDefault();
  //     event.returnValue = "";
  //     innerRef.current?.setOnlineStatus("unavailable")

  //     localStorage.setItem("isRefresh", "true");

  //     // const res_data = await fetchData(
  //     //   "post",
  //     //   { status: "unavailable", usertype: "agent", windowClose: "TabClosed" },
  //     //   AGENT_ACTIVITY
  //     // );

  //     console.log("beforeunload event triggered");
  //     return "";
  //   };

  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleTabClose);
  //   };
  // }, [auth]);

  // const hasLoadedPermissions =
  //   Array.isArray(auth?.permissions?.data) || Array.isArray(auth?.permissions);
  // const isAuthReady =
  //   Boolean(auth?.accessToken) &&
  //   Boolean(auth?.user_details?.user) &&
  //   Array.isArray(auth?.roles) &&
  //   auth.roles.length > 0 &&
  //   hasLoadedPermissions;
  // const agentRoutes = useMemo(
  //   () => (isAuthReady ? getRoutesByAuth(auth) : []),
  //   [auth, isAuthReady]
  // );
  const agentRoutes = getRoutesByAuth(auth);

  return (
    <SIPProvider>
      {showMultiTabWarning && tabCounterEnd && (
        <div
          className="multi-tab-warning"
          onClick={() => tabCounterEndCounterHandle()}
          style={{
            position: "fixed",
            top: "16px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "8px 16px",
            background: "#ffffff",
            color: "#1e293b",
            border: "1px solid #fed7aa",
            borderTop: "3px solid #f59e0b",
            borderRadius: "8px",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
            fontSize: "13px",
            fontWeight: 500,
            zIndex: 9999,
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              background: "#fef3c7",
              color: "#d97706",
              flexShrink: 0,
              fontSize: "11px",
            }}
          >
            ⚠️
          </span>

          <span>
            <strong style={{ color: "#b45309", marginRight: "4px" }}>Multiple Tabs Open:</strong>
            Status updates may be inconsistent.
          </span>

          <span
            style={{
              marginLeft: "6px",
              color: "#94a3b8",
              fontSize: "14px",
              fontWeight: "bold",
              lineHeight: 1,
            }}
          >
            ✕
          </span>
        </div>
      )}
      <Routes>
        {/* Public Route */}
        {CommonRoutes.map((Menu, index) => (
          <Route key={index} path={Menu.path} element={Menu.component} />
        ))}

        <Route path="/" element={<Layout auth={auth} />}>
          {/* Agent Paths */}
          <Route path="/" element={<PersistLogin ref={innerRef} />}>
            <Route
              path="agent"
              element={<RequireAuth allowedRoles={[ROLES.Agent, ROLES.ContactAdmin]} />}
            >
              {agentRoutes.map((Menu, index) => (
                <Route key={index} path={Menu.path} element={Menu.component} />
              ))}
            </Route>
            <Route
              key="customer-list"
              path="customer-list/"
              element={<AgentCustomerList />}
            ></Route>
            {/* Admin Routes */}
            <Route
              path="admin"
              element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.ContactAdmin]} />}
            >
              {Adminroutes.map((Menu, index) => (
                <Route key={index} path={Menu.path} element={Menu.component} />
              ))}
              <Route
                key="new_campaign"
                path="campaign/create/:id"
                element={<NewCampaign />}
              />
              <Route
                key="customer_list"
                path="customer/list/"
                element={<NewCampaign />}
              />
              <Route
                key="new_agent"
                path="agent/create/:id"
                element={<AddUser />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </SIPProvider>
  );
}

export default App;